import { render, staticRenderFns } from "./PageEmailVerification.vue?vue&type=template&id=c0671fcc"
import script from "./PageEmailVerification.vue?vue&type=script&lang=js"
export * from "./PageEmailVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports